var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagementApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M40.5547 69.3845C50.519 69.1973 70.5583 62.8705 71.0011 39.061",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M43.3209 63.2075L37.7852 69.3845L43.3209 75",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M39.4453 7.61504C29.481 7.80222 9.44174 14.129 8.99889 37.9385",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M36.6791 13.7915L42.2148 7.61451L36.6791 1.99906",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M8.83938 66.2971V67.5671H10.1094H26.7298H27.9998V66.2971V61.6488C27.9998 57.7586 24.8461 54.605 20.9559 54.605H15.8832C11.993 54.605 8.83938 57.7586 8.83938 61.6488V66.2971Z",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M23.213 48.9748V48.5079C23.213 45.7718 20.995 43.5537 18.2588 43.5537C15.5227 43.5537 13.3047 45.7718 13.3047 48.5079V48.9748C13.3047 51.7109 15.5227 53.929 18.2588 53.929C20.995 53.929 23.213 51.7109 23.213 48.9748Z",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M50.9097 25.8654V27.1354H52.1797H68.8001H70.0701V25.8654V21.2172C70.0701 17.327 66.9165 14.1734 63.0263 14.1734H57.9535C54.0633 14.1734 50.9097 17.327 50.9097 21.2172V25.8654Z",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M65.2833 8.54415V8.07721C65.2833 5.3411 63.0653 3.12305 60.3292 3.12305C57.5931 3.12305 55.375 5.3411 55.375 8.07721V8.54415C55.375 11.2803 57.5931 13.4983 60.3292 13.4983C63.0653 13.4983 65.2833 11.2803 65.2833 8.54415Z",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementApps);
export default __webpack_public_path__ + "static/media/engagement_apps.e9822c67fca19f0d82e45bf82d13c815.svg";
export { ForwardRef as ReactComponent };